import { FunctionComponent } from 'react'
import classNames from 'classnames'
import {
  SectionAttributes,
  SectionOrientation,
  Section as SectionProps
} from './Section.types'
import { UXComponentRenderer } from '../UXComponentRenderer/UXComponentRenderer'
import { Label } from '../primitives/Label/Label'
import { Text } from '../primitives/Text/Text'
import { Button } from '../primitives/Button/Button'
import './Section.scss'

const getCustomStyles = (attributes: SectionAttributes) => {
  const style: React.CSSProperties = {}

  if (attributes.padding) {
    style.padding = attributes.padding
  }

  return style
}

export const Section: FunctionComponent<SectionProps> = ({ attributes }) => {
  return (
    <div
      className={classNames('core-ux-section', {
        'core-ux-section--with-top-divider': attributes.showTopDivider,
        'core-ux-section--with-bottom-divider': attributes.showBottomDivider,
        'core-ux-section--horizontal':
          attributes.orientation === SectionOrientation.HORIZONTAL
      })}
      data-testid="section"
      style={getCustomStyles(attributes)}>
      {(attributes.title || attributes.description || attributes.button) && (
        <div className="core-ux-section__header">
          <div className="core-ux-section__title">
            {attributes.title && <Label {...attributes.title} />}
            {attributes.description && <Text {...attributes.description} />}
          </div>

          {attributes.button && <Button {...attributes.button} />}
        </div>
      )}
      <div
        className={classNames('core-ux-section__body', {
          'core-ux-section__body--horizontal':
            attributes.orientation === SectionOrientation.HORIZONTAL,
          'core-ux-section__body--vertical':
            attributes.orientation === SectionOrientation.VERTICAL
        })}>
        {attributes.content.map((component, index) => (
          <UXComponentRenderer
            key={`${component.type}-${index}`}
            {...component}
          />
        ))}
      </div>
    </div>
  )
}
